import { render, staticRenderFns } from "./PayslipsDataTable.vue?vue&type=template&id=4aeb82c8"
import script from "./PayslipsDataTable.vue?vue&type=script&lang=js"
export * from "./PayslipsDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports